import { render, staticRenderFns } from "./ExpandAltIcon.vue?vue&type=template&id=764757f5&"
import script from "./ExpandAltIcon.vue?vue&type=script&lang=js&"
export * from "./ExpandAltIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports